/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-02 17:55:01
 * @modify date 2020-04-02 17:55:01
 * @desc [description]
 */
<template>
  <div id="app">
    <notifications position="bottom right" />
    <custom-notification></custom-notification>
    <router-view></router-view>
    <v-dialog />
  </div>
</template>

<script>
import $ from 'jquery';
import CustomNotification from './components/Common/ULNotifications.vue';

export default {
  name: 'app',
  components: {
    CustomNotification,
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
};
</script>
